import React from 'react'
import { Button, Form } from '../../../ui'

/**
 * @param {Object[]} fields
 * @param {boolean} isButtonDisabled
 * @param {string} buttonName
 * @param {func} onSubmit
 * @param {boolean} isLoadingSubmit
 */
const FormWithoutSteps = ({ fields, isButtonDisabled, buttonName, onSubmit, isLoadingSubmit }) => {
  return (
    <Form>
      {fields}
      <Button
        disabled={isButtonDisabled}
        onClick={onSubmit}
        isLoading={isLoadingSubmit}
      >
        {buttonName}
      </Button>
    </Form>
  )
}

export { FormWithoutSteps }
